import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { Button } from './ui/Button';
export function BenefitsSection() {
  const benefits = ['menos minutos de caos máximo', 'menos sensación de «no sé qué hago»', 'menos cambios impulsivos que lo empeoran', 'una rutina PM mínima que puedes repetir', 'más calma en tu cuerpo (y eso se nota)'];
  const forYou = ['eres mamá primeriza', 'tu bebé tiene 0–12 semanas', 'el final del día se complica casi siempre', 'quieres pasos claros, no teoría infinita'];
  const notForYou = ['buscas «duerme 12 horas» o promesas irreales', 'quieres diagnóstico médico o tratamiento', 'hay señales de alarma (en ese caso, pediatra)'];
  return <section className="py-12 px-4 md:px-6 bg-[#faf6f0]" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        {/* Benefits */}
        <div className="mb-10" data-id="element-3">
          <h2 className="font-serif text-2xl md:text-4xl text-[#1a2e4a] font-bold mb-5 text-center" data-id="element-4">
            Qué cambia cuando tienes un guion
          </h2>

          <div className="bg-white p-5 md:p-8 rounded-3xl shadow-sm border border-[#d4a0a0]/20" data-id="element-5">
            <p className="text-base text-[#5a5a5a] mb-5 font-medium" data-id="element-6">
              No te prometo un bebé «perfecto». Te prometo algo más útil:
            </p>

            <ul className="space-y-3 mb-5" data-id="element-7">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-3" data-id="element-8">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#c4956a]/20 flex items-center justify-center" data-id="element-9">
                    <Check className="w-3.5 h-3.5 text-[#c4956a]" data-id="element-10" />
                  </div>
                  <span className="text-base text-[#1a2e4a]" data-id="element-11">{benefit}</span>
                </motion.li>)}
            </ul>

            <div className="bg-[#1a2e4a]/5 p-4 rounded-xl border-l-4 border-[#1a2e4a]" data-id="element-12">
              <p className="font-serif text-base text-[#1a2e4a] italic" data-id="element-13">
                «Porque lo que tu bebé necesita no es que seas «experta».
                Necesita consistencia cuando el día se deshace.»
              </p>
            </div>
          </div>
        </div>

        {/* CTA Mid-page */}
        <div className="text-center mb-10" data-id="element-14">
          <a href="https://plenava.com/cart/52227852173659id1:1" target="_blank" rel="noopener noreferrer" data-id="element-15">
            <Button size="lg" className="px-10 py-5 text-lg" data-id="element-16">
              Quiero el kit (6,39€)
            </Button>
          </a>
        </div>

        {/* For Who / Not For Who */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-5 md:p-6 rounded-2xl border-t-4 border-[#c4956a] shadow-sm" data-id="element-18">
            <h3 className="font-serif text-xl font-bold text-[#1a2e4a] mb-4" data-id="element-19">
              Es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-20">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-21">
                  <Check className="w-5 h-5 text-[#c4956a] mt-0.5" data-id="element-22" />
                  <span className="text-sm text-[#5a5a5a]" data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-5 md:p-6 rounded-2xl border-t-4 border-[#5a5a5a] shadow-sm opacity-80" data-id="element-24">
            <h3 className="font-serif text-xl font-bold text-[#5a5a5a] mb-4" data-id="element-25">
              No es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-26">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-27">
                  <X className="w-5 h-5 text-[#5a5a5a] mt-0.5" data-id="element-28" />
                  <span className="text-sm text-[#5a5a5a]" data-id="element-29">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}